import { createSelector } from '@ngrx/store';
import { AppState } from '../index';
import { SupportState } from './support.reducer';

export const $supportState = (state: AppState): SupportState => state.support;

export const $sitePhoneCall = createSelector(
    $supportState,
    state => state.phoneCall,
);

export const $siteActivities = createSelector(
    $supportState,
    state => state.activities,
);
